
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "row": "row-4c26b8b3",
    "fit-width": "fit-width-4c26b8b3",
    "fit-height": "fit-height-4c26b8b3",
    "fit-both": "fit-both-4c26b8b3",
    "center": "center-4c26b8b3",
    "middle": "middle-4c26b8b3",
    "spacing-none": "spacing-none-4c26b8b3",
    "spacing-normal": "spacing-normal-4c26b8b3",
    "spacing-narrow": "spacing-narrow-4c26b8b3",
    "spacing-wide": "spacing-wide-4c26b8b3",
    "fitWidth": "fit-width-4c26b8b3",
    "fitHeight": "fit-height-4c26b8b3",
    "fitBoth": "fit-both-4c26b8b3",
    "spacingNone": "spacing-none-4c26b8b3",
    "spacingNormal": "spacing-normal-4c26b8b3",
    "spacingNarrow": "spacing-narrow-4c26b8b3",
    "spacingWide": "spacing-wide-4c26b8b3"
};
exports.styleSource = ".row-4c26b8b3{display:flex;flex-direction:row}.fit-width-4c26b8b3{width:100%}.fit-height-4c26b8b3{height:100%}.fit-both-4c26b8b3{width:100%;height:100%}.center-4c26b8b3{justify-content:center}.middle-4c26b8b3{align-items:center}.spacing-none-4c26b8b3>*{margin:0}.spacing-normal-4c26b8b3>*{margin-right:1em}.spacing-normal-4c26b8b3>*:last-child{margin-right:0}.spacing-narrow-4c26b8b3>*{margin-right:.5em}.spacing-narrow-4c26b8b3>*:last-child{margin-right:0}.spacing-wide-4c26b8b3>*{margin-right:2em}.spacing-wide-4c26b8b3>*:last-child{margin-right:0}";
exports.default = exports.styles;
            
module.moduleType = "style";
